import { render, staticRenderFns } from "./BalanceDocumentTable.vue?vue&type=template&id=72df66cd&scoped=true&"
import script from "./BalanceDocumentTable.vue?vue&type=script&lang=js&"
export * from "./BalanceDocumentTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72df66cd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/vagrant/interfaces/online/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib'
installComponents(component, {VDataTable})
